module.exports = __webpack_public_path__ + "static/media/icwdial_102.de575c7e.ico";